import { Link, useLocation } from 'react-router-dom';

interface TitleProps {
  name?: string;
  role?: string;
  className?: string;
}

export const Title: React.FC<TitleProps> = ({
  name = 'Amandine Quellec',
  role = 'Creative Developer',
  className = '',
}) => {
  const { pathname } = useLocation();
  const from = pathname === '' ? 'home' : pathname.substring(1) || 'home';

  return (
    <div className={`flex flex-col ${className}`}>
      <Link
        to="/"
        state={{ from }}
        className="hover:opacity-70 transition-opacity"
      >
        <h1 className="text-2xl font-medium text-black">{name}</h1>
        <h2 className="text-xl font-normal text-black/60">{role}</h2>
      </Link>
    </div>
  );
};
